import ContactForm from "./ContactForm";


const ContactContainer = () => {


    return ( 

        <section className="contactContainer" >
            <ContactForm  />
        </section>

     );
}
 
export default ContactContainer;